import { authorizedApi } from './index';

export const tokenSubmissionApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    submitToken: builder.mutation({
      query: (
        params = {
          tokenAddress,
          giftCardImage,
          logoImage,
          network,
          projectURI,
        },
      ) => ({
        url: '/token-submission',
        method: 'POST',
        body: {
          ...params,
        },
      }),
    }),
    approveToken: builder.mutation({
      query: (
        params = {
          id,
        },
      ) => ({
        url: `/token-submission/${params.id}/approve`,
        method: 'POST',
      }),
    }),
    rejectToken: builder.mutation({
      query: (
        params = {
          id,
        },
      ) => ({
        url: `/token-submission/${params.id}/reject`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useSubmitTokenMutation,
  useApproveTokenMutation,
  useRejectTokenMutation,
} = tokenSubmissionApi;
